import { render, staticRenderFns } from "./grid-range-size.vue?vue&type=template&id=40c10586&"
import script from "./grid-range-size.vue?vue&type=script&lang=js&"
export * from "./grid-range-size.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports